export const EstadoCivil = {
  1: 'Solteiro(a)',
  2: 'Casado(a)',
  3: 'Viúvo(a)',
  4: 'Separado(a)',
  5: 'Divorciado(a)',
  6: 'Amancebado(a)'
}



// WEBPACK FOOTER //
// ./src/domain/comitentes/helpers/PessoaStatus.js